import React, {useContext} from "react";
import { useHistory } from "react-router-dom";
import "../scss/activity.scss";
import web from "../assets/activities/web.jpg";
import marketing from "../assets/activities/marketing.jpg";
import other from "../assets/activities/other.png";

import {NewProjectContext} from "../context/NewProjectContext";

const CardActivity = ({ name, title, imgCard }) => {
  const { handleNeed } = useContext(NewProjectContext);
  const history = useHistory();

  const onClick = () => {
    handleNeed(name);
    history.push("/newproject/pack");
  };

  return (
    <div className="activity-card-container" onClick={onClick}>
      <img src={imgCard} alt="Illustration" />
      <div className="activity-title">{title}</div>
    </div>
  );
};

const BranchActivityContainer = () => {
  return (
    <div className="activity-container">
      <h1 className="title">Nos secteurs d'activités</h1>
      <div className="cards-container">
        <CardActivity name="Informatique & Web" title="web" imgCard={web} />
        <CardActivity name="Marketing" title="marketing" imgCard={marketing} />
        <CardActivity name="Autre" title="autres" imgCard={other} />
      </div>
    </div>
  );
};

export default BranchActivityContainer;
